define('controllers/hotelnewsearch',['require','layout','models','utils','moment','services/bookingService','components/map','rv!templates/partials/messenger','rv!templates/partials/hotelRating','rv!templates/partials/star','rv!templates/partials/halfStar','rv!templates/booking/hotel-new-search'],function(require) {

    'use strict';
    var layout = require('layout');
    var models = require('models');
    var utils = require('utils');
    var moment = require('moment');
    var bookingService = require('services/bookingService');
    var Map = require('components/map');

    var UNITED_STATES_CENTER = { lat: 39.443256, lng: -98.95734 };

    return {
        load: function (qs, data, state) {
            state.regions ? this._init(state) : 
                $.get('/api/hotels/getregions').then(function (regions) {
                    state.regions = regions;
                    this._init(state);
                }.bind(this));
        },
        _init: function (state) {
            this.state = state;

            var searchItems = utils.getLastSearch();
            var mapToggle = utils.getMapViewToggle();

            var partials = {
                messenger: require('rv!templates/partials/messenger'),
                hotelRating: require('rv!templates/partials/hotelRating'),
                star: require('rv!templates/partials/star'),
                halfStar: require('rv!templates/partials/halfStar'),
            };

            this.ractive = layout.initRactive({
                loading: false,
                contentUrl: window.ServerData.StaticContentUrl,
                providers: models.provider
            }, require('rv!templates/booking/hotel-new-search'), {
                twoway: true,
                partials: partials,
                modifyArrays: false
            });

            this._setSearchMeta(searchItems);

            var lastViewedDestination = utils.getLastViewedDestination();
            this._setBreadCrumbs(lastViewedDestination);

            if (lastViewedDestination != null) {
                var searched = this.ractive.get('searchMeta');

                if (searched.region == null || searched.region.value === '' || searched.region.value !== lastViewedDestination.RegionName) {
                    searched.region = {
                        Latitude: lastViewedDestination.Latitude,
                        Longitude: lastViewedDestination.Longitude,
                        id: parseInt(lastViewedDestination.Id),
                        value: lastViewedDestination.RegionName
                    };

                    this.ractive.set('searchMeta', searched);
                    searched = this._updateSearchMeta();

                    if(!$('#map-toggle').is(':checked')) {
                        var updateMapView = {
                            region: searched.region,
                            zoom: 8, // minimum hotel view zoom
                            center: {
                                lat: lastViewedDestination.Latitude,
                                lng: lastViewedDestination.Longitude
                            },
                        };
                        utils.setLastViewedRegion(updateMapView);
                    }
                }

            }

            var mapValidation = this._mapValidation(searchItems.fromDate, searchItems.toDate);

            if (mapToggle && mapValidation) {
                $('#map-toggle').prop('checked', true);
                this._initMap();
            } else {
                $('#map-toggle').prop('checked', false);
                $('#map_canvas').hide();

                // If the dates to search by the map feature are invalid/past dates, the map switch will be
                // toggled off and disabled until valid dates are entered
                if (!mapValidation) {
                    $('#map-toggle').prop('disabled', true);
                }
            }
            
            this._initDateBoxEvents();
            this._initAutocomplete();
            this._initGuestEvents();
            
            // Init search results state
            this.ractive.set('hotelResults', this.state.searchResults);
            this.ractive.set('pageMap', null);
            this.ractive.set('loadingResults', false);
            this.ractive.set('provider', models.provider);
            layout.initGlobalHandlers();

            $('.hotel-search-form .search-changeable').on('change', function() {
                this._updateSearchMeta();
                utils.setLastViewedDestination(null);

                // If the user updates the destination while the map view is off, 
                // the viewed region will need to be reset in order to pan to 
                // the map destination if toggled back on
                if(!$('#map-toggle').is(':checked')) {
                    var resetMap = {
                        region: null,
                        zoom: 5,
                        center: UNITED_STATES_CENTER,
                    };
                    utils.setLastViewedRegion(resetMap);
                }
            }.bind(this));

            this._updateMapEvents();

            $('#childAgeInput').on('change', 'input', function() {
                this._updateSearchMeta();
            }.bind(this));
            this._initHotelSearch();
        },

        _initMap: function() {
            var mapcanvas = $('#map_canvas');
            mapcanvas.show();

            var _regions = [];
            var searchMeta = this.ractive.get('searchMeta');

            $.get('/api/hotels/getmapregionsbydate/?fromDate={0}&toDate={1}'.format(searchMeta.fromDate, searchMeta.toDate)).then(function(regions) {
                regions.forEach(function(region) {
                    _regions.push(region);
                }.bind(this));

                if (this.map != null) {
                    this.map.updateMapSearchData(searchMeta.fromDate, searchMeta.toDate, _regions);
                    this.map.update(_regions);
                } else {
                    this.map = new Map(mapcanvas, _regions, searchMeta.fromDate, searchMeta.toDate);
                    $('#map_canvas').on('click', '#map-reset', function() {
                        this.clearResults();
                        searchMeta.region = null;
                        this.ractive.set('searchMeta', searchMeta);
                        searchMeta = this._updateSearchMeta();
                    }.bind(this));
                }

                this.map.onLoad(function() { return this.ractive.set('loading', false); }.bind(this));
            }.bind(this));
        },

        _updateSearchFromMap: function() {
            var searchMeta = this.ractive.get('searchMeta');
            var lastMapSearch = utils.getLastViewedRegion();

            var noRegionHotel = lastMapSearch.region == null && (searchMeta.region == null || searchMeta.region != null);
            
            if ((lastMapSearch.region == null && searchMeta.region == null) || (lastMapSearch.region != null && searchMeta.region != null) || (lastMapSearch.region != null && searchMeta.region == null) || noRegionHotel) {
                this.clearResults();
                searchMeta.region = lastMapSearch.region;
                this.ractive.set('searchMeta', searchMeta);
                searchMeta = this._updateSearchMeta();
                utils.setLastViewedDestination(null);
            }
        },

        _updateMapFromSearch: function() {
            if (($('#map-toggle').is(':checked') && this.map != null)) {
                this.map.updateMapView();
                
                // The region value of the search meta is set to "" but the remaining 
                // values are still assigned (id, keywords, etc.)
                var searched = this.ractive.get('searchMeta');
                if (searched.region.value === '') {
                    searched.region = null;
                    this.ractive.set('searchMeta', searched);
                    searched = this._updateSearchMeta();
                }
            }
        },

        _updateMapEvents: function() {
            // If the text destination search has changed, the map will update the view to focus on that region
            $('.hotel-destination-inputs-container .search-changeable').not('#mileageSelector').on('change', function() {
                if ($('#map-toggle').is(':checked') && this.map != null) {
                    this._updateMapFromSearch();
                }
            }.bind(this));

            // The map will be re-updated with the new date range and grab regions/hotels with the new date range
            $('#dateInputs .search-changeable').on('change', function() {
                var searchMeta = this.ractive.get('searchMeta');
                var mapValidation = this._mapValidation(searchMeta.fromDate, searchMeta.toDate);
                if ($('#map-toggle').is(':checked') && this.map != null && mapValidation) {
                    this._initMap();
                }
            }.bind(this));

            // Checks to see if the user wants to use the map feature to search, if toggled to 'unchecked',
            // the map will be destroyed and if re-toggled to 'checked', the map will re-initialize itself
            $('#map-toggle').on('click', function() {
                var searchMeta = this.ractive.get('searchMeta');
                var mapValidation = this._mapValidation(searchMeta.fromDate, searchMeta.toDate);

                utils.setMapViewToggle($('#map-toggle').is(':checked'));

                // If the dates to search by the map feature are invalid/past dates, the map will not
                // update until valid dates are entered, if the user toggles the map switch to be off,
                // the switch will be disabled until valid dates are entered
                if (mapValidation) {
                    if ($('#map-toggle').is(':checked')) {
                        this._initMap();
                    } else {
                        this.map.destroy();
                        this.map = null;
                        $('#map_canvas').hide();
                    }
                } else {
                    $('#map-toggle').prop('disabled', true);
                    this.map.destroy();
                    this.map = null;
                    $('#map_canvas').hide();
                }
            }.bind(this));

            // This listens for a click on the map and will communicate with the region or hotel marker being clicked to
            // save the last viewed region
            $('#map_canvas').on('click', function () { 
                this._updateSearchFromMap(); // only updates if clicked region and search bar are out of sync
            }.bind(this));
        },

        _updateSearchMeta: function() {
            var searchMeta = this.ractive.get('searchMeta');

            var buffAges = $('#childAgeInput input').toArray().map(function (input) {
                return $(input).val();
            });

            searchMeta.childrenAges = new Array(searchMeta.children);
            for (var i = 0; i < searchMeta.children; i++) {
                searchMeta.childrenAges[i] = buffAges[i] ? buffAges[i] : 0;
            }

            searchMeta.page = 1;
            searchMeta.size = 5;
            searchMeta.processed = { HotelbedsCount : 0};
            searchMeta.total = { AdestinnTotal : 0};

            this._setSearchMeta(searchMeta);
            utils.setLastSearch(searchMeta);
            this.clearResults();

            return searchMeta;
        },

        _pageSearchMeta: function() {
            var searchMeta = this.ractive.get('searchMeta');
            searchMeta.page += 1;
            searchMeta.size = 5; 
            this.ractive.set('searchMeta', searchMeta);
        },

        clearResults: function () {
            this.ractive.set('hotelResults', null);
            this.ractive.set('loadingResults', false);
            this.state.searchResults = null;
        },

        _initGuestEvents: function() {
            $('#hotelGuestsButton').on('click', function (e) {
                e.stopPropagation();
                $('.hotel-guest-inputs-container').toggle();
            });

            // Close occupant popup
            $('body').on('click', function(e) {
                var context = $(this);
                // when event is not hotelGuestsButton
                if (context.attr('id') !== 'hotelGuestsButton') {
                    // and event is not a child of the .hotel-guest-inputs-container
                    if (!$(e.target).is('.hotel-guest-inputs-container *, .hotel-guest-inputs-container')) {
                        $('.hotel-guest-inputs-container').hide();
                    }
                }
            });
        },

        _initHotelSearch: function() {
            $('#hotelSearchButton').on('click', function () {
                var searchForm= $('.hotel-search-form :input');
                this.ractive.set('messenger', null);
                var searchMeta = this.ractive.get('searchMeta');

                this.ractive.set('pageMap', null);
                console.log('SENDING', searchMeta);
                if (this._formValidation(searchForm, searchMeta.region)) {
                    this._disableInputs();
                    this._updateSearchMeta();
                    this._resetForm(searchForm);
                    this._getHotels();
                }
            }.bind(this));
        },

        _getHotels: function() {
            var searchMeta = this.ractive.get('searchMeta');
            this.ractive.set('loadingResults', true);
            $('#map-reset').prop('disabled', true);
            $('#map-reset').css('background-color', '#f0f0f0');
            $.postJSON('/api/hotels/search', {
                regionId: searchMeta.region.id,
                fromDate: searchMeta.fromDate,
                toDate: searchMeta.toDate,
                mileage: searchMeta.mileage,
                adults: searchMeta.adults,
                children: searchMeta.children,
                childrenAges: searchMeta.childrenAges,

                total: searchMeta.total,
                processed: searchMeta.processed,
                page: searchMeta.page,
                size: searchMeta.size
            }).then(function (page) {
                if (this.ractive === null) {
                    this.unload();
                    return;
                }
                page.Hotels.forEach(function (r) {
                    if(r !== undefined) {
                        r.DisplayAddress = this.getDisplayAddress(r);
                        r.BookingUrl = this.getBookUrl(r, searchMeta.region);
                    }
                }.bind(this));
                var oldTels = this.ractive.get('hotelResults');
                if(oldTels === null) {
                    oldTels = [];
                }

                oldTels = oldTels.concat(page.Hotels);

                this.ractive.set('hotelResults', oldTels);
                this.state.searchResults = oldTels;
                this.ractive.set('loadingResults', false);

                
                var pageMap = this.ractive.get('pageMap');
                if(pageMap === null) {
                    pageMap = {};
                }

                pageMap[page.Page] = page;
                this.ractive.set('pageMap', pageMap);

                // Only the newest page continues the search. The keys used to be
                // compared as STRINGS ("10" > "9" is false), so the search stopped
                // after page 10 and left the search inputs disabled. Compare numbers.
                var expected = Math.max.apply(null, Object.keys(pageMap).map(Number));
                // Safety cap so a server that never returns an empty page can't page forever.
                var MAX_PAGES = 40;

                console.log('expected: ', expected, ', page: ', page.Page);
                if (expected === Number(page.Page)) {
                    //Update search variables
                    var search = this.ractive.get('searchMeta');
                    search.total = page.Total;
                    search.processed = page.Processed;
                    if (page.Hotels.length !== 0 && Number(page.Page) < MAX_PAGES) {
                        this._pageSearchMeta();
                        this._getHotels();
                    } else {
                        this._enableInputs();
                    }
                }
                $('#map-reset').prop('disabled', false);
                $('#map-reset').css('background-color', '#ffffff');
            }.bind(this), function (error) {
                this.ractive.set('loadingResults', false);
                this.ractive.set('hotelResults', null);
                this.ractive.set('pageMap', null);
                this.state.searchResults = null;
                this.ractive.set('messenger.Errors', window.Utilities.getFriendlyErrors(error) ||
                                    'ERROR | Status Code: ' + error.status + ' - ' + error.statusText);
            }.bind(this));
        },

        _initAutocomplete: function() {
            $('#destination').autocomplete({
                source: function(request, response) {
                    if (this.state.regions.length > 0) {
                        var term = request.term.toLowerCase();
                        var buff = [];
                        var results = this.state.regions.filter(function(x) {
                            buff = x.keywords.filter(function(k) { return k.includes(term); }.bind(this));
                            if (x.value.toLowerCase().includes(term) ||
                                buff != null && buff.length > 0) {
                                return x;
                            }
                        }.bind(this));
                        // Limit to 10 displayed results
                        if (results.length > 0) {
                            response(results.slice(0, 15));
                        } else {
                            response([{label: 'No results found', id: -1}]);
                        }    
                    }
                }.bind(this),
                response: function(event, ui) {
                    if (ui.content.length > 0) {
                        var searchMeta = this.ractive.get('searchMeta');
                        searchMeta.region = ui.content[0];
                        this.ractive.set(searchMeta);
                    }
                }.bind(this),
                select: function(event, ui) {
                    event.stopPropagation();
                    var searchMeta = this.ractive.get('searchMeta');
                    searchMeta.region = ui.item;
                }.bind(this),
                minLength:2 
            }).bind(this);

            // Add enter button as shortcut for selection
            $('#destination').keypress(function(e) {
                if (e.which === 13) {
                    $('#destination').blur();
                    $('#destination').autocomplete('close');
                    $('#hotelSearchButton').click();
                    return false;
                }
            }.bind(this));
        },

        _updateChildrenAges: function() {
            $('#childAgeInput').empty();
            $('#childAgeInput').show();
            var inputNumber = $('input#childrenNumber').val();
            
            var ages = this.ractive.get('searchMeta.childrenAges');

            if (inputNumber > 0 && inputNumber <= 10) {
                var buff = 0;
                for (var i = 0; i < inputNumber; i++) {
                    if (ages[i] != null) {
                        buff = ages[i];
                    } else {
                        buff = 0;
                    }
                    $('#childAgeInput').append('<label for=childAge' + (i + 1) + '>Child #' + (i + 1) + ' Age: </label><input type=number value=' + buff + ' min=0 max=17 id=childAge' + (i + 1) + ' />');
                }
            } else {
                $('#childAgeInput').hide();
            }
        },

        _disableInputs: function() {
            $('.hotel-search-form :input').prop('disabled', true);
        },

        _enableInputs: function() {
            $('.hotel-search-form :input').prop('disabled', false);
        },
        
        _setSearchMeta: function(items) {
            this.ractive.set('searchMeta', items);
            this._updateChildrenAges();

            if (items.adults <= 1) {
                this.ractive.set('adultTag', 'adult');
            } else if (items.adults > 1) {
                this.ractive.set('adultTag', 'adults');
            }

            if (items.children <= 1) {
                this.ractive.set('childTag', 'child');
            } else if (items.children > 1) {
                this.ractive.set('childTag', 'children');
            }
        },

        _initDateBoxEvents: function() {
            var from = $('#fromDate');
            var to = $('#toDate');

            from.on('change', function(e) {
                if (from.val() >= to.val()) {
                    var date = moment(from.val());
                    date.add(1, 'days');
                    var c = date.format('YYYY-MM-DD');
                    to.val(c);
                    var data = this.ractive.get('searchMeta');
                    data.toDate = c;
                }
            }.bind(this));

            to.on('blur', function(e) {
                if (to.val() <= from.val()) {
                    var date = moment(to.val());
                    date.subtract(1, 'days');
                    var c = date.format('YYYY-MM-DD');
                    from.val(c);
                    var data = this.ractive.get('searchMeta');
                    data.fromDate = c;
                }            
            }.bind(this));
        },

        getDisplayAddress: function (h) {
            var value = utils.isNullOrWhiteSpace(h.DisplayAddress)
                ? '{0}, {2}, {3}, {4} {5}'.format(h.Address1 || '', h.Address2 || '', h.City || '', h.StateProvince || '', h.Country || '', h.PostalCode || '') // jshint ignore:line
                : h.DisplayAddress;
            return value.replace(/[!@$%^&*()?":{}|<>]/g, '');
        },

        _destroyLazyDom: function() {
            if (this.lazyDom != null) {
                this.lazyDom.destroy();
            }  
        },

        /**
         * build a url to the hoteldetail page with the given planning data.
         * @param {PlanningData} planningData 
         * @returns {string} 
         */
        getBookUrl: function (event, region) {
            var planningData = {
                DestinationInfo: {
                    VRegion: {
                       RegionName: region.value,
                       RegionID: region.id,
                    } 
                },
                Provider: event.ProviderCode,
            };
            var qs = bookingService.serializePlanning(planningData);
            return qs;
        },
        
        _resetForm: function (formInputs) {
            if (formInputs != null) {
                for (var x = 0; x < formInputs.length; x++) {
                    var element = $(formInputs[x]);
                    this._validateBox(element, true);
                }
            }
        },

        _mapValidation: function (fromDate, toDate) {
            var _fromDate = moment(fromDate);
            var _toDate = moment(toDate);
            var today= moment();
            today.set({hour:0,minute:0,second:0,millisecond:0});

            var valid = true;
            var errors = [];

            if (!_fromDate.isValid() || !_toDate.isValid()) {
                errors.push('(From:) date is not valid');
                valid = false;
            }
            if (!_toDate.isValid()) {
                errors.push('(To:) date is not valid');
                valid = false;
            }

            if (_fromDate < today) {
                errors.push('(From:) date must be in the future');
                valid = false;
            } 
            if (_toDate < today) {
                errors.push('(To:) date must be in the future');
                valid = false;
            } 

            if (_fromDate >= _toDate) {
                errors.push('(From:) date must be before (To:) date');
                valid = false;
            }

            if (moment(_toDate).diff(moment(_fromDate), 'day') > 14) {
                errors.push('(From:) date and (To:) date must be within 14 days.');
                valid = false;
            }

            this.ractive.set('messenger.Errors', errors);

            if (utils.getMapViewToggle() && !valid) {
                $('#map-toggle').prop('disabled', false);
            } else if (!utils.getMapViewToggle() && !valid) {
                $('#map-toggle').prop('disabled', true);
            } else if (valid) {
                $('#map-toggle').prop('disabled', false);
            }

            return valid;
        },

        _formValidation: function (formInputs, destination) {
            var valid = true;
            var guestButton = $('#hotelGuestsButton');
            var fromDate;
            var toDate;
            var fromDateElement;
            var toDateElement;
            var errors = [];

            if (formInputs != null) {
                for (var x = 0; x < formInputs.length; x++) {
                    var element = $(formInputs[x]);
                    var id = element.attr('id');
                    var value = element.val();
                    if (id === 'destination') {
                        if (destination == null || 
                            destination.value == null || 
                            destination.value === '' || 
                            destination.id == null || 
                            destination.id <= 0) {

                            errors.push('Invalid destination');
                            this._validateBox(element, false);
                            valid = false;
                        }
                    } else if (id === 'fromDate') {
                        fromDateElement = element;
                        fromDate = moment(value);
                        if (!fromDate.isValid()) {
                            errors.push('(From:) date is not valid');
                            this._validateBox(element, false);
                            valid = false;
                        }
                    } else if (id === 'toDate') {
                        toDateElement = element;
                        toDate = moment(value);
                        if (!toDate.isValid()) {
                            errors.push('(To:) date is not valid');
                            this._validateBox(element, false);
                            valid = false;
                        } 
                    } else if (id === 'adultNumber') {
                        if (value === '' || value <= 0 || value > 10) {
                            errors.push('Invalid number of adults selected');
                            this._validateBox(element, false);
                            this._validateBox(guestButton, false);
                            valid = false;
                        }
                    } else if (id === 'childrenNumber') {
                        if (value === '' || value < 0 || value > 10) {
                            errors.push('Invalid number of children selected');
                            this._validateBox(element, false);
                            this._validateBox(guestButton, false);
                            valid = false;
                        }
                    } else if (id.startsWith('childAge')) {
                        if (value === '' || value < 0 || value > 17) {
                            errors.push('Invalid child age selected. Ages must be between 0 and 17');
                            this._validateBox(element, false);
                            this._validateBox(guestButton, false);
                            valid = false;
                        }
                    }
                    // Date verification
                    // fromDate cannot be before toDate
                    // fromDate cannot be before Date.now()
                    // toDate cannot be before Date.now()
                    if (fromDate != null && toDate != null &&
                        fromDate.isValid() && toDate.isValid()) {
                        var today= moment();
                        today.set({hour:0,minute:0,second:0,millisecond:0});

                        if (toDate < today) {
                            errors.push('(To:) date must be in the future');
                            this._validateBox(toDateElement, false);
                            valid = false;
                        } else if (fromDate < today) {
                            errors.push('(From:) date must be in the future');
                            this._validateBox(fromDateElement, false);
                            valid = false;
                        } else if (fromDate >= toDate) {
                            errors.push('(From:) date must be before (To:) date');
                            this._validateBox(fromDateElement, false);
                            this._validateBox(toDateElement, false);
                            valid = false;
                        } else if (moment(toDate).diff(moment(fromDate), 'day') > 14) {
                            errors.push('(From:) date and (To:) date must be within 14 days.');
                            this._validateBox(fromDateElement, false);
                            this._validateBox(toDateElement, false);
                            valid = false;
                        }
                        fromDate = null;
                        toDate = null;
                    }
                }

                this.ractive.set('messenger.Errors', errors);

                return valid;
            }
            return false;
        },

        _validateBox: function(box, valid) {
            box.css('border', valid ? '' : '1px solid #eed3d7');
            box.css('background-color', valid ? '' : '#f2dede');
            box.css('color', valid ? '' : '#6E0A03');
        },

        _setBreadCrumbs: function (previousViewed) {
            var breadcrumbs = [{
                name: 'Destinations',
                url: '/#/destinations'
            }];

            if (previousViewed != null) {  
                breadcrumbs.push({
                    name: previousViewed.RegionName,
                    url: previousViewed.href
                });
            }

            breadcrumbs.push({
                name: 'Hotel Search',
            });

            layout.setBreadCrumbs(breadcrumbs);
        },

        unload: function() {
            if (this.ractive != null) {
                this.ractive.teardown();
            }
            if (this.lazyload != null) {
                this.lazyload.destroy();
            }
            this._destroyLazyDom();
            this.lazyload = null;
            this.state = null;
            this.lazyDom = null;
            this.ractive = null;
            this.map = null;
            this.$window = null;
        }
    };
});

